export class GmMemberLookupQueryParameters {
  APIKey?: string | null;
  EmailAddress?: string | null;
  FirstName?: string | null;
  GCIN?: string | null;
  GMFAccountNbr?: string | null;
  LastFour?: string | null;
  LastName?: string | null;
  MemberNumber?: string | null;
  OnStarAccountNbr?: string | null;
  PhoneNumber?: string | null;
  ProfileId?: string | null;
  SourceCode?: string | null;
  SurrogateId?: string | null;
  ZipCode?: string | null;

  constructor(obj?: GmMemberLookupQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
